import { createButton } from '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
export class UnderlinePlugin {
    constructor() {
        this.name = 'underline';
        this.spec = {
            type: 'mark',
            // iOS 选中文字后自带的气泡工具使用的 <u> 标签
            matchSelector: 'u',
            matchStyle: {
                'text-decoration': (deco) => /\bunderline\b/.test(deco) && {},
            },
            attrs: {
                builtIns: {
                    toDOMAttribute: () => ({ style: 'text-decoration: underline' }),
                },
            },
            toDOM: 'span',
        };
        this.toggle = () => this.editor.selection().toggleMark(this);
        this.isActive = () => this.editor.isActive(this);
        this.canApply = () => this.editor.selection().canToggleMark(this);
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                toggle: this.toggle,
                isActive: this.isActive,
            },
            shortcuts: {
                'Mod-u': this.toggle,
            },
        };
    }
    renderToolbarItem() {
        const btn = createButton({
            label: this.editor.t('下划线'),
            shortcut: 'Mod-u',
            onclick: () => {
                this.editor.focus();
                this.toggle();
            },
        }, createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.underlineIcon),
        }));
        const setBtnProps = () => {
            btn.active = this.isActive();
            btn.disabled = !this.canApply();
        };
        setBtnProps();
        this.editor.on('idlechange', setBtnProps);
        return btn;
    }
}
//# sourceMappingURL=index.js.map